import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  feedbackService,
  FeedbackParams,
} from '@/services/api/feedbackService';

interface FeedbackState {
  isLoading: boolean;
  error: string | null;
  isSubmitted: boolean;
}

const initialState: FeedbackState = {
  isLoading: false,
  error: null,
  isSubmitted: false,
};

export const submitFeedback = createAsyncThunk(
  'feedback/submitFeedback',
  async (params: FeedbackParams, { rejectWithValue }) => {
    try {
      const response = await feedbackService.submitFeedback(params);
      return response;
    } catch (error: unknown) {
      const message =
        error instanceof Error ? error.message : 'Failed to submit feedback';
      return rejectWithValue(message);
    }
  }
);

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    resetFeedbackType: state => {
      state.isSubmitted = false;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(submitFeedback.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(submitFeedback.fulfilled, state => {
        state.isLoading = false;
        state.isSubmitted = true;
        setTimeout(() => {
          sessionStorage.clear();
        }, 1000);
      })
      .addCase(submitFeedback.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export default feedbackSlice.reducer;
